import React from 'react';
import { Typography } from '@mui/material';

const Footer = () => (
<Typography variant="h5" sx={{ fontSize: { lg: '28px', xs: '20px' } }} mt="41px" textAlign="center" pb="40px">Made with ❤️ by Brandon</Typography>
);

export default Footer;

